import { render } from "./PageContainer.vue?vue&type=template&id=943b12f2&scoped=true&lang=true"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"

import "./PageContainer.vue?vue&type=style&index=0&id=943b12f2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-943b12f2"]])

export default __exports__